import { render, staticRenderFns } from "./JudicialProcessFilePage.vue?vue&type=template&id=50619cae"
import script from "./JudicialProcessFilePage.vue?vue&type=script&lang=js"
export * from "./JudicialProcessFilePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports